<template>
  <div>
    <!-- If I have Planned Stages -->
    <b-message type="is-info" v-if="plannedStages.length > 0">
      <p>
        Cliquez sur les cours ci-dessous pour ajouter <span v-html="customersFirstname" /> aux créneaux que vous souhaitez.
      </p>
      <ul class="stages-customer-and-levels">
        <stage-customers-summary-customer-item
          v-for="(customer, customerLevelIndex) of customersWithLevels"
          :key="`customer-level-index-${customerLevelIndex}`"
          :planned-stages="plannedStages"
          :customer="customer"
        />
      </ul>
    </b-message>

    <!-- If I doesn't have Planned Stages -->
    <b-message v-else type="is-warning">
      Il n'y a pas de cours qui correspondent à l'âge et au niveau de <span v-html="customersFirstname" />.
    </b-message>
  </div>
</template>

<script>
import StageCustomersSummaryCustomerItem from "@/components/partial/stagesPlanner/StageCustomersSummaryCustomerItem";

export default {
  name: "StageCustomersSummary",
  components: { StageCustomersSummaryCustomerItem },
  props: {
    customers: {
      type: Array,
      required: true
    },
    customersWithLevels: {
      type: Array,
      required: true
    },
    plannedStages: {
      type: Array,
      required: true
    },
    registrationStagesByCustomers: {
      type: Array
    }
  },

  computed: {
    customersFirstname() {
      const customers = [];
      for (const customer of this.customersWithLevels) {
        if (customer.age >= 18) {
          customers.push(`<strong>${customer.firstname} ${customer.lastname}</strong>`);
        } else {
          customers.push(`<strong>${customer.firstname}</strong>`);
        }
      }
      if (customers.length === 1) {
        return customers[0];
      } else if (customers.length === 2) {
        return `${customers[0]} et ${customers[1]}`;
      } else if (customers.length > 2) {
        const lastCustomer = customers.pop();
        return `${customers.join(", ")} et ${lastCustomer}`;
      } else {
        return "";
      }
    }
  }
};
</script>
